exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payoff-adjustments .one-time-payment-date .vdp-datepicker .vdp-datepicker__calendar{right:0}.one-time-payment-date .vdp-datepicker div input{width:100%!important}.one-time-payment-date .vdp-datepicker .vdp-datepicker__calendar{right:0}", ""]);

// exports
